// @flow

import 'prelude';

import {withGuards} from 'app/rgs/utils';
import {profile} from 'myrgs-auth-helpers';

import menuApi from './api';
import MenuHtmlTemplate from './templates/index.html';

const menuOptions = {
	view: {
		selector: 'nfd-my-top-navigation',
		template: MenuHtmlTemplate,
	},
};

(async (): Promise<void> => {
	await profile.updateAtLeastOnce();

	if (!profile.IsAuthenticated()) {
		return;
	}

	withGuards(menuApi.setup(menuOptions).render);
})();
